import React, { Component, Fragment, useEffect, useLayoutEffect, useRef, useState } from "react";
import Viewers from "react-images-viewer";
import i18n from "../../../../../constants/initLng";
import "./VideoImageViewer.less";
import { Carousel, Icon, Modal } from "antd";

const imgType = ['jpeg', 'jpg', 'png'];

const VideoImageViewer = (props) => {
  //! State
  const carouselRef = useRef(null);
  const { isOpen, isPreview3x3, onClickThumbnail } = props;

  //! Function
  const handleClickThumbnail = (index) => {
    carouselRef.current.innerSlider.slickGoTo(index);
    onClickThumbnail(index)
  }

  const handlePrevSlide = () => {
    props.onClickPrev();
    carouselRef.current.innerSlider.slickPrev();
  }
  const handleNextSlide = () => {
    props.onClickNext();
    carouselRef.current.innerSlider.slickNext();
  }
  //! Effect

  //! View
  const renderFooter= () => {
    return <div className="footer-wrap">
      {props.thumbnails.map((thumb,index) => {
        const type = thumb.split(".")[thumb.split(".").length - 1];
        if(imgType.includes(type)){
          return(
            <div key={index} className={`${props.currImg === index ? 'is-active footer-wrap-item' : 'footer-wrap-item'}`} onClick={() => handleClickThumbnail(index)}>
              <img src={thumb} alt={thumb}/>
            </div>
          )
        }
        return(
          <div key={index} className={`${props.currImg === index ? 'is-active footer-wrap-item' : 'footer-wrap-item'}`} onClick={() => handleClickThumbnail(index)}>
            <video 
              style={{objectFit:'cover'}}
              controls={false}
              src={thumb}
              width={`100%`}
              height={`100%`}
              className={`cursorPointer`}/>
          </div>
        )
      })}
    </div>
  }

  //! Render
  return (
      <Modal
        centered={true}
        visible={isOpen}
        okButtonProps={{style: {display: 'none'}}}
        cancelButtonProps={{style: {display: 'none'}}}
        footer={renderFooter()}
        width='100%'
        onCancel={props.onClose}
        className="modal-slide"
        closable={false}
        closeIcon={null}
      >
        <Carousel dots={false}
          visible
          style={{maxWidth: '1024px'}}
          initialSlide={props.currImg} ref={carouselRef}
        >
            {props.thumbnails.map((el, index) => {
                const type = el.split(".")[el.split(".").length - 1];
                if (imgType.includes(type)) {
                    return (
                      <div className="carousel-wrap" >
                        <Icon className="carousel-close cursorPointer" onClick={props.onClose} type="close" />
                        <img key={index} style={{ objectFit:'cover'}} src={el} alt={el}/>
                      </div>
                    )
                }
                return (
                  <div className="carousel-wrap" >
                    <Icon className="carousel-close cursorPointer" onClick={props.onClose} type="close" />
                    <video key={index} style={{objectFit:'cover'}} controls={false} src={el} className={`cursorPointer`}/>
                  </div>
                )
            })}
        </Carousel>
        <Icon className="icon-left" type="left" onClick={handlePrevSlide}/>
        <Icon className="icon-right" type="right" onClick={handleNextSlide}/>
      </Modal>
  );
};

export default VideoImageViewer;
